var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartWithPrimaryColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    fill: "none",
    viewBox: "0 0 36 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M23.775 4.252c.947 0 1.892.133 2.79.435 5.537 1.8 7.531 7.875 5.865 13.185a19.092 19.092 0 0 1-4.514 7.213 57.684 57.684 0 0 1-9.496 7.44l-.375.227-.39-.242a57.14 57.14 0 0 1-9.553-7.44 19.4 19.4 0 0 1-4.517-7.198c-1.695-5.31.3-11.385 5.897-13.217a6.78 6.78 0 0 1 1.333-.313h.18c.421-.062.84-.09 1.26-.09h.165c.945.028 1.86.193 2.746.495h.089c.06.028.105.06.135.088.332.107.645.227.945.392l.57.255c.138.073.292.185.426.282.085.062.16.117.219.153l.075.043c.128.075.262.154.375.24a9.395 9.395 0 0 1 5.775-1.948Zm3.99 10.8a1.234 1.234 0 0 0 1.185-1.141v-.179c.045-2.101-1.229-4.005-3.165-4.74a1.201 1.201 0 0 0-1.515.75c-.21.63.12 1.32.75 1.544.961.36 1.605 1.306 1.605 2.355v.046a1.29 1.29 0 0 0 .285.93c.21.255.525.404.855.435Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.774,
    x2: 32.159,
    y1: 5.473,
    y2: 51.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF281"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartWithPrimaryColor);
export default __webpack_public_path__ + "static/media/heart_with_primary_color.36e5fac57ed10362f8a3040d19288d22.svg";
export { ForwardRef as ReactComponent };